import { useTranslation } from 'react-i18next';

import bowSundress from '../../assets/bow-sundress.png';
import buttonTank from '../../assets/button-tank.png';
import floralDress from '../../assets/floral-dress.png';
import pleatedSkirt from '../../assets/pleated-skirt.png';
import squareTank from '../../assets/square-tank.png';
import tieWaistTank from '../../assets/tie-waist-tank.png';

import { ProductGrid } from './ProductGrid';

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/components/ui/Select';

export function VisualMerchandise() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Personalization.components.VisualMerchandise',
  });

  const products = [
    {
      id: 1,
      name: t('products.bowTieSundress'),
      price: '$89.99',
      image: bowSundress,
    },
    {
      id: 2,
      name: t('products.floralRoseDress'),
      price: '$99.99',
      image: floralDress,
    },
    {
      id: 3,
      name: t('products.buttonFrontTank'),
      price: '$59.99',
      image: buttonTank,
    },
    {
      id: 4,
      name: t('products.pleatedMidiSkirt'),
      price: '$69.99',
      image: pleatedSkirt,
    },
    {
      id: 5,
      name: t('products.squareNeckPeplum'),
      price: '$49.99',
      image: squareTank,
    },
    {
      id: 6,
      name: t('products.tieWaistCamisole'),
      price: '$54.99',
      image: tieWaistTank,
    },
  ];

  return (
    <div className="border-t border-gray-200 bg-gray-50 p-6">
      <div className="space-y-6">
        <div className="mb-6 rounded-lg border bg-white p-6 shadow-sm">
          <h3 className="mb-1 text-xl font-medium">{t('title')}</h3>

          <p className="mb-3 text-sm text-gray-600">{t('description')}</p>

          <div className="mb-4 border-l-4 border-green-500 bg-green-100 p-4">
            <p className="text-green-700">
              <strong>{t('personalizationAlert.title')}</strong>{' '}
              {t('personalizationAlert.text')}
            </p>
          </div>

          <div className="mb-4 flex items-center justify-between">
            <div>
              <span className="text-sm text-gray-500">
                {t('showingLabel', { count: 6, total: 24 })}
              </span>
            </div>

            <div className="flex items-center">
              <span className="mr-2 text-sm text-gray-700">
                {t('sortByLabel')}
              </span>

              <Select defaultValue="personalized">
                <SelectTrigger className="w-[220px]">
                  <SelectValue placeholder="Sort by" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="personalized">
                    {t('sortOptions.personalized')}
                  </SelectItem>
                  <SelectItem value="lowToHigh">
                    {t('sortOptions.lowToHigh')}
                  </SelectItem>
                  <SelectItem value="highToLow">
                    {t('sortOptions.highToLow')}
                  </SelectItem>
                  <SelectItem value="newest">
                    {t('sortOptions.newest')}
                  </SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>

        <ProductGrid products={products} />
      </div>
    </div>
  );
}
